import React, {useEffect} from 'react'
import ReactDOM from 'react-dom/client'
import App from '@jobmatchme/main/es/components/App'
import {I18nextProvider} from 'react-i18next'
import {IntlProvider} from 'react-intl'
import * as Sentry from '@sentry/react'
import i18n from '@jobmatchme/main/es/i18n'
import SimpleErrorPage from '@jobmatchme/ui/es/components/SimpleErrorPage'
import {getUrlLocale} from '@jobmatchme/utils/es/getUrlParam'
import './index.css'
import {createSessionResource} from '@jobmatchme/react-auth/es/Provider'

// Prepare the resource
const SessionResource = createSessionResource().prepare()

const SSRContainer = () => {
  // Google Tag Manager and CMP Banner setup scripts
  useEffect(() => {
    const gtmIframe = () => {
      const noscript = document.createElement('noscript')
      noscript.innerHTML = `<iframe src="https://sst.jobmatch.me/ns.html?id=GTM-P3QG85G" height="0" width="0" style="display:none;visibility:hidden"></iframe>`
      return noscript
    }

    const gtmScript = () => {
      const script = document.createElement('script')
      script.setAttribute('type', 'text/plain')
      script.setAttribute('data-cookieconsent', 'statistics, marketing')
      script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src="https://sst.jobmatch.me/e3h6upoomisft.js?"+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','PageDataLayer','8n=aWQ9R1RNLVAzUUc4NUc%3D&page=3');`
      return script
    }
    const cmpScript = () => {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://consent.cookiebot.com/uc.js')
      script.setAttribute('data-cbid', '8e8ef52f-8246-463d-8a92-cdcb4da9921f')
      script.setAttribute('type', 'text/javascript')
      script.async = true
      script.setAttribute('id', 'Cookiebot')
      return script
    }
    if (document) {
      document.head.insertBefore(gtmScript(), document.head.childNodes[0])
      document.head.insertBefore(cmpScript(), document.head.childNodes[0])
      document.body.insertBefore(gtmIframe(), document.body.childNodes[0])
    }
  }, [])

  useEffect(() => {
    if (
      typeof navigator !== 'undefined' &&
      navigator.userAgent !== 'critical'
    ) {
      const timer = setTimeout(() => {
        const jssStyles = document.getElementById('jss-server-side')
        if (jssStyles) {
          jssStyles.parentElement.removeChild(jssStyles)
        }
        const ssrStyles = document.getElementById('critical-server-side')
        if (ssrStyles) {
          ssrStyles.parentElement.removeChild(ssrStyles)
        }
      }, 1000)
      return () => clearTimeout(timer)
    }
  })
  return (
    <IntlProvider locale={getUrlLocale()}>
      <I18nextProvider i18n={i18n}>
        <Sentry.ErrorBoundary fallback={SimpleErrorPage}>
          <App sessionResource={SessionResource} />
        </Sentry.ErrorBoundary>
      </I18nextProvider>
    </IntlProvider>
  )
}

const container = document.getElementById('root')

ReactDOM.hydrateRoot(container, <SSRContainer />)

if (module.hot) {
  module.hot.accept()
}
